import Vue from 'vue'
import Vuex from 'vuex'

import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

import { initialState } from './state'

import { ADVANCED_SEARCH_NAMESPACE, AdvancedSearch } from './advanced-search'
import { ASYLUM_ASSISTANT_NAMESPACE, AsylumAssistant } from './asylum-assistant'
import { AUTHENTICATION_NAMESPACE, Authentication } from './authentication'
import { CALENDAR_NAMESPACE, Calendar } from './calendar'
import { CHECKLIST_NAMESPACE, Checklist } from './checklist'
import { CONTACT_DETAILS_WIZARD_NAMESPACE, ContactDetailsWizard } from './contact_details_wizard'
import { DASHBOARD_NAMESPACE, Dashboard } from './dashboard'
import { DOCKET_ENTRY_NAMESPACE, DocketEntry } from './docket-entry'
import { DOCKET_ENTRY_TYPE_NAMESPACE, DocketEntryType } from './docket-entry-type'
import { DOWNLOADS_NAMESPACE, Downloads } from './downloads'
import { ELIGIBILITY_ASSISTANT_NAMESPACE, EligibilityAssistant } from './eligibility-assistant'
import { ENGAGEMENT_LETTER_NAMESPACE, EngagementLetter } from './engagement-letter'
import { FAST_SEARCH_NAMESPACE, FastSearch } from './fast-search'
import { GOOGLE_CALENDAR_NAMESPACE, GoogleCalendar } from './google-calendar'
import { IMPORT_PARTY_NAMESPACE, ImportParty } from './import-party'
import { INTEGRATION_NAMESPACE, Integrations } from './integrations'
import { LEGAL_CASE_NAMESPACE, LegalCase } from './legal-case'
import { LEGAL_CASE_TYPE_NAMESPACE, LegalCaseType } from './legal-case-type'
import { LOG_NAMESPACE, Log } from './log'
import { LONG_TERM_OPTIONS_NAMESPACE, LongTermOptions } from './long-term-options'
import { MASS_REASSIGNMENT_NAMESPACE, MassReassignment } from './mass-reassignment'
import { NOTIFICATION_NAMESPACE, Notifications } from './notification'
import { PARTY_NAMESPACE, Party } from './party'
import { RECORD_NAMESPACE, Record } from './record'
import { REPORTS_NAMESPACE, Reports } from './reports'
import { SETTINGS_NAMESPACE, Settings } from './settings'
import { SHARED_NAMESPACE, Shared } from './shared'
import { SHORT_MESSAGE_NAMESPACE, ShortMessage } from './short-message'
import { TEAM_NAMESPACE, Team } from './team'
import { USER_NAMESPACE, User } from './user'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: initialState,
  getters,
  mutations,
  actions,
})

// Module Registration
store.registerModule(ADVANCED_SEARCH_NAMESPACE, AdvancedSearch)
store.registerModule(ASYLUM_ASSISTANT_NAMESPACE, AsylumAssistant)
store.registerModule(AUTHENTICATION_NAMESPACE, Authentication)
store.registerModule(CALENDAR_NAMESPACE, Calendar)
store.registerModule(CHECKLIST_NAMESPACE, Checklist)
store.registerModule(CONTACT_DETAILS_WIZARD_NAMESPACE, ContactDetailsWizard)
store.registerModule(DASHBOARD_NAMESPACE, Dashboard)
store.registerModule(DOCKET_ENTRY_NAMESPACE, DocketEntry)
store.registerModule(DOCKET_ENTRY_TYPE_NAMESPACE, DocketEntryType)
store.registerModule(DOWNLOADS_NAMESPACE, Downloads)
store.registerModule(ELIGIBILITY_ASSISTANT_NAMESPACE, EligibilityAssistant)
store.registerModule(ENGAGEMENT_LETTER_NAMESPACE, EngagementLetter)
store.registerModule(FAST_SEARCH_NAMESPACE, FastSearch)
store.registerModule(GOOGLE_CALENDAR_NAMESPACE, GoogleCalendar)
store.registerModule(IMPORT_PARTY_NAMESPACE, ImportParty)
store.registerModule(INTEGRATION_NAMESPACE, Integrations)
store.registerModule(LEGAL_CASE_NAMESPACE, LegalCase)
store.registerModule(LEGAL_CASE_TYPE_NAMESPACE, LegalCaseType)
store.registerModule(LOG_NAMESPACE, Log)
store.registerModule(LONG_TERM_OPTIONS_NAMESPACE, LongTermOptions)
store.registerModule(NOTIFICATION_NAMESPACE, Notifications)
store.registerModule(MASS_REASSIGNMENT_NAMESPACE, MassReassignment)
store.registerModule(PARTY_NAMESPACE, Party)
store.registerModule(RECORD_NAMESPACE, Record)
store.registerModule(REPORTS_NAMESPACE, Reports)
store.registerModule(SETTINGS_NAMESPACE, Settings)
store.registerModule(SHARED_NAMESPACE, Shared)
store.registerModule(SHORT_MESSAGE_NAMESPACE, ShortMessage)
store.registerModule(TEAM_NAMESPACE, Team)
store.registerModule(USER_NAMESPACE, User)

export default store
